import {Add} from '@material-ui/icons';
import React from 'react';

export function AddIcon() {
  return <Add fontSize="small" color="primary" />;
}
